module.exports = __webpack_public_path__ + "img/goods_default.2ca1eb45.svg";